<div class="container">
    <div class="title-header">
        <div class="title-left">
            <span class="material-icons-outlined">filter_alt</span>
            <span class="title-text">{{ "filter.title" | translate }}</span>
        </div>
    </div>
    <div class="filter-buttons">
        <button
            *ngFor="let filterObj of filters; let i = index; let last = last"
            (click)="applyFilter(filterObj.filter.code)"
            class="filter-button filter-kind-{{ filterObj.kind }} {{ filterObj.disabled ? 'disabled' : '' }}"
            [ngClass]="{'archived-filter': last}"
            [disabled]="filterObj.disabled"
            >
            <span>{{ filterObj.label | translate }}</span>
        </button>
    </div>

    <filter-form *ngIf="selectedFilterCode"></filter-form>
</div>